import { Component, Input, output } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { ICartItem, ICombinedExtra } from 'core-lib';
import { ShopcartService } from 'core-lib';
import { IExtraCartItem } from 'core-lib';
import { IncrementorComponent } from 'core-lib';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { getExtraMaxQty, getExtraUiType } from '../extras/extras-pricing.helper';
import { TagModule } from 'primeng/tag';

@Component({
    selector: 'app-edit-extra-dialog',
    imports: [ButtonModule, DialogModule, TranslateModule, IncrementorComponent, CurrencyPipe, DatePipe, TagModule],
    templateUrl: './edit-extra-dialog.component.html',
    styleUrl: './edit-extra-dialog.component.scss'
})
export class EditExtraDialogComponent {

  @Input() extrasToEdit:null|IExtraCartItem[] = null
  // the unit price shown on the extra's card; the rooms' own totals can differ (e.g. per adult)
  @Input() unitPrice:null|number = null;
  @Input() unitPriceLabel = '';
  @Input() testId: string;

  onChangeQuantity = output<any>();
  onClose = output();
  rooms:ICartItem[];

  language: string;
  dialogOpen:boolean = false;
  personsPerRoom:number[] = [];
  adultsPerRoom:number[] = [];
  childrenPerRoom:number[] = [];
  nights:number = 1;
  constructor(private shopCartService: ShopcartService, private translateService: TranslateService) {

  }

  ngOnInit() {
    this.language = this.translateService.currentLang;

    let cart = this.shopCartService.getCart();
    if (cart) {
      this.nights = cart.getDaysDelta() ?? 1;
      this.rooms = cart.getCartItemsByType('roomrate');
      this.rooms.forEach((room, index) => {
        const roomData = room.getSearchParams().roomData[index];
        this.adultsPerRoom.push(roomData?.adults ?? 0);
        this.childrenPerRoom.push(roomData?.children ?? 0);
        this.personsPerRoom.push((roomData?.adults ?? 0) + (roomData?.children ?? 0));
      });
    }

  }

  ngOnChanges() {
    this.dialogOpen = this.extrasToEdit ? true : false;
  }

  onEditQuantityChange($event:any, $index:number) {
    let emitObj = {
      "event": $event,
      "index": $index
    };
    this.onChangeQuantity.emit(emitObj);
  }
  closeClick() {
    this.onClose.emit();
  }

  isFixedExtra(extra: IExtraCartItem): boolean {
    return getExtraUiType(extra) === 'fixed';
  }

  isCheckboxExtra(extra: IExtraCartItem): boolean {
    return getExtraUiType(extra) === 'checkbox';
  }

  getExtraMaxQtyForRoom(extra: IExtraCartItem, roomIndex: number): number {
    const nights = this.shopCartService.getCart()?.getDaysDelta() ?? 1;
    const persons = this.personsPerRoom[roomIndex] ?? 1;
    return getExtraMaxQty(extra, nights, persons);
  }

  // same functionality in extras.component //TODO:FIX
  getExternalMaxQuantity(externalExtra:ICombinedExtra) {
      //calculate how many tickets sellable, if ticket is selected for another room
      // or the cart already has a ticket with the same eventid.
      if (!externalExtra.remainingQuantity) {
        return 0;
      }
      let availableTickets:number = externalExtra.remainingQuantity;
      let alreadyInCart:number = 0;
      let eventId = externalExtra.event?.id
      let cartItems = this.shopCartService.getCart()?.getCartItemsByType('roomrate');
      cartItems?.forEach((cartItem) => {
        let sameEventIds = cartItem.extras.filter(extra => extra.event?.id == eventId);
        sameEventIds.forEach(element => {
          alreadyInCart += element.quantity
        });
      })
      return availableTickets - alreadyInCart;
  }
}
